<template>
  <section v-if="screenContent" class="scene scene--friends">
    <!-- background -->
    <div class="floor">
      <picture>
        <source
          srcset="@/assets/images/village/floor-slope.webp 700w"
          type="image/webp"
          sizes="500px"
        >
        <img
          class="floor__slope"
          alt="Floor Slope"
          src="@/assets/images/village/floor-slope.png"
          srcset="@/assets/images/village/floor-slope.png 700w"
          width="104"
          height="331"
          sizes="500px"
        >
      </picture>
    </div>
    <!-- people -->
    <FriendsNpc1 v-if="screenContent.NPC1" :npcs="screenContent.NPC1" :speechbubble="screenContent.SpeechBubble" />
    <FriendsNpc2 v-if="screenContent.NPC2" :npcs="screenContent.NPC2" />
    <!-- signpost -->
    <div class="sign">
      <button class="chevron chevron--left" @click="friendsPrev">
        <svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line class="chevron__line" x1="21" y1="3.53553" x2="3.53553" y2="21" stroke="white" stroke-width="5" stroke-linecap="round"/>
          <line class="chevron__line" x1="2.5" y1="-2.5" x2="27.1985" y2="-2.5" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 21 42)" stroke="white" stroke-width="5" stroke-linecap="round"/>
        </svg>
      </button>
      <button class="chevron chevron--right" @click="friendsNext">
        <svg width="24" height="42" viewBox="0 0 24 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line class="chevron__line" x1="2.5" y1="-2.5" x2="27.1985" y2="-2.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 3 0)" stroke="white" stroke-width="5" stroke-linecap="round"/>
          <line class="chevron__line" x1="3" y1="38.4645" x2="20.4645" y2="21" stroke="white" stroke-width="5" stroke-linecap="round"/>
        </svg>
      </button>
      <Friend v-if="activeFriend" :friend="activeFriend" />
    </div>
    <!-- modal -->
    <transition name="fade">
      <Modal v-if="modal && activeFriend" :friend="activeFriend" />
    </transition>
    <!-- arrows -->
    <Arrow direction="right" theme="purple" @click="clickVillage" />
    <!-- content -->
    <div class="content content--top">
      <div class="container">
        <div class="title">
          <h2 v-if="screenContent.Heading" class="mb-1">
            {{ screenContent.Heading }}
          </h2>
          <h4 v-if="screenContent.SubHeading">
            {{ screenContent.SubHeading }}
          </h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Arrow from '@/components/parts/Arrow.vue'
import Friend from '@/components/parts/Friend.vue'
import Modal from '@/components/parts/Modal.vue'
import FriendsNpc1 from '@/components/npcs/FriendsNpc1.vue'
import FriendsNpc2 from '@/components/npcs/FriendsNpc2.vue'

export default {
  name: 'Friends',

  components: {
    Arrow,
    Friend,
    Modal,
    FriendsNpc1,
    FriendsNpc2
  },

  data () {
    return {
      activeFriend: null,
      activeFriendIndex: 0
    }
  },

  computed: {
    screenContent () {
      return this.$store.getters.getContentFriends
    },
    sceneName () {
      return this.$store.getters.getSceneName
    },
    modal () {
      return this.$store.getters.getModal
    }
  },

  watch: {
    screenContent () {
      this.setActiveFriend()
    }
  },

  mounted () {
    this.$gtm.trackEvent({
      'event': 'View Landing Page Section',
      'lp_section': this.sceneName,
      'lp_loc': '1L'
    })
    this.setActiveFriend()
  },

  methods: {
    clickVillage () {
      this.$gtm.trackEvent({
        'event': 'Back from Friends'
      })
      this.$store.dispatch('setScene', 'village')
    },
    friendsPrev () {
      this.$gtm.trackEvent({
        'event': 'Friend Navigation',
        'lp_NavDirection': 'Left'
      })
      this.activeFriendIndex = this.activeFriendIndex - 1
      this.setActiveFriend()
    },
    friendsNext () {
      this.$gtm.trackEvent({
        'event': 'Friend Navigation',
        'lp_NavDirection': 'Right'
      })
      this.activeFriendIndex = this.activeFriendIndex + 1
      this.setActiveFriend()
    },
    setActiveFriend () {
      if (this.screenContent) {
        if (this.screenContent.Friends) {
          if (this.activeFriendIndex < 0) {
            this.activeFriendIndex = this.screenContent.Friends.length - 1
          }
          if (this.activeFriendIndex >= this.screenContent.Friends.length) {
            this.activeFriendIndex = 0
          }
          if (this.screenContent.Friends.length > this.activeFriendIndex) {
            this.activeFriend = this.screenContent.Friends[this.activeFriendIndex]
          }
          if (this.activeFriend.Title) {
            this.$gtm.trackEvent({
              'event': 'View User',
              'lp_friendName': this.activeFriend.Title
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins.scss';

.scene--friends {
  overflow: visible;
}
.content--top {
  padding-top: 80px;

  @include breakpoint(md) {
    padding-top: 100px;
  }
}
.title {
  display: none;

  h4 {
    display: none;
  }

  @include breakpoint(370px) {
    @include breakpointHeight(730px) {
      display: block;
    }
    @include breakpointHeight(800px) {
      h4 {
        display: block;
      }
    }
  }
  @include breakpoint(662px) {
    @include breakpointHeight(705px) {
      display: block;
    }
    @include breakpointHeight(755px) {
      h4 {
        display: block;
      }
    }
  }
  @include breakpoint(lg) {
    display: none;

    h4 {
      display: none;
    }

    @include breakpointHeight(865px) {
      display: block;
    }
    @include breakpointHeight(910px) {
      h4 {
        display: block;
      }
    }
  }
}
.floor {
  position: absolute;
  z-index: 3;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 190px;
  background-image: url('../../../assets/images/village/flooring.png');
  background-position: top right;
  background-repeat: repeat-x;
  background-size: auto 236px;
  display: none;

  @include breakpointHeight(md) {
    display: block;
  }
}
.floor__slope {
  position: absolute;
  z-index: 1;
  top: 2px;
  left: 100%;
  height: 480px;
  width: auto;
  display: none;

  @include breakpointHeight(md) {
    display: block;
  }
}

.sign {
  position: absolute;
  z-index: 2;
  bottom: 0;
  left: 50%;
  width: 400px;
  height: 100%;
  transform: translateX(-50%);

  @include breakpointHeight(md) {
    bottom: 180px;
  }

  @include breakpoint(lg) {
    width: 540px;
  }
}
.chevron {
  top: auto;
  bottom: 180px;

  @include breakpoint(lg) {
    @include breakpointHeight(md) {
      bottom: 250px;
    }
  }

  &--left {
    left: 35px;

    @include breakpoint(sm) {
      left: 0;
    }
  }
  &--right {
    right: 40px;

    @include breakpoint(sm) {
      right: 15px;
    }
  }
}
</style>
